import { getString } from '../locale'

export function readableTime(milliseconds: number, small: boolean = false): string {
    const DAYS = getString(!small ? 'time.days' : 'time.d')
    const HOURS = getString(!small ? 'time.hours' : 'time.h')
    const MINUTES = getString(!small ? 'time.minutes' : 'time.m')
    const SECONDS = getString(!small ? 'time.seconds' : 'time.s')
    let message = ''
    // if (milliseconds >= 1000) {
    const seconds = Math.floor((milliseconds / 1000) % 60)
    const minutes = Math.floor((milliseconds / (1000 * 60)) % 60)
    const hours = Math.floor((milliseconds / (1000 * 60 * 60)) % 24)
    const days = Math.floor(milliseconds / (1000 * 60 * 60 * 24))
    if (!small) {
        if (days === 0 && hours !== 0) {
            message = `${hours} ${HOURS} ${minutes} ${MINUTES} ${seconds} ${SECONDS}`
        } else if (hours === 0 && minutes !== 0) {
            message = `${minutes} ${MINUTES} ${seconds} ${SECONDS}`
        } else if (days === 0 && hours === 0 && minutes === 0) {
            message = `${seconds} ${SECONDS}`
        } else {
            message = `${days} ${DAYS} ${hours} ${HOURS} ${minutes} ${MINUTES} ${seconds} ${SECONDS}`
        }
    } else {
        if (days === 0 && hours !== 0) {
            message = `${hours}${HOURS} ${minutes}${MINUTES} ${seconds}${SECONDS}`
        } else if (hours === 0 && minutes !== 0) {
            message = `${minutes}${MINUTES} ${seconds}${SECONDS}`
        } else if (days === 0 && hours === 0 && minutes === 0) {
            message = `${seconds}${SECONDS}`
        } else {
            message = `${days}${DAYS} ${hours}${HOURS} ${minutes}${MINUTES} ${seconds}${SECONDS}`
        }
    }
    // } else {
    //     message = getString('time.less_than_a_second')
    // }
    return message
}
